export default "__VITE_ASSET__BknyQUNA__"